export default () => {
    let timelineSteps = document.querySelectorAll('.js-timelineSteps');

    if (!timelineSteps.length)
        return;

    timelineSteps.forEach(function (item) {
        let moveSize = window.innerWidth < 768 ? 200 : 350;
        let trigger = item.nextElementSibling;
        let reset   = trigger.nextElementSibling;
        calcWidth(item, trigger, reset, moveSize);
    });

    function calcWidth(item, trigger, reset, moveSize) {
        let init = 0;
        let moved = 0;
        let width = item.getClientRects()[0].width;
        let windowWidth = window.innerWidth;

        if (windowWidth > 1240) {
            init = -((windowWidth / 2) - 620);
        }

        moved = init;

        if (width > (windowWidth + moved)) {
            item.classList.add('scrollable');
        }

        reset.addEventListener('click', function (e) {
            e.preventDefault();

            item.style.transform = '';
            item.classList.remove('resetable');
            item.classList.remove('reached-end');
            moveSize = window.innerWidth < 768 ? 200 : 350;
            moved = init;
        });

        trigger.addEventListener('click', function (e) {
            e.preventDefault();

            if (width > (windowWidth + moved)) {
                item.style.transform = `translateX(-${moveSize}px)`;
                item.classList.add('resetable');
                moved+= window.innerWidth < 768 ? 200 : 350;
                moveSize+=window.innerWidth < 768 ? 200 : 350;
            } else {
                item.classList.add('reached-end');
            }

        });

        window.addEventListener('resize', function () {
            width = item.getClientRects()[0].width;
            windowWidth = window.innerWidth;

            if (windowWidth > 1240) {
                init = -((windowWidth / 2) - 620);
            }

            if (width > (windowWidth + moved)) {
                item.classList.add('scrollable');
            } else {
                item.classList.remove('scrollable');
            }

            item.style.transform = '';
            item.classList.remove('resetable');
            item.classList.remove('reached-end');
            moveSize = window.innerWidth < 768 ? 200 : 350;
            moved = init;
        });
    }
}